<template>
  <div id="Information" class="full_layout information">
    <h3 class="informationTitle">TERMS & CONDITIONS</h3>
    <div class="informationBox">
      <ul class="useragreement">
        <li>
          <div class="t1">1. Scope</div>
          <p >These Terms and Conditions apply to all orders placed via the online shop of:</p>
          <p>Cardhobby Germany GmbH</p>
          <p>Luisenstraße 9, 40215 Düsseldorf</p>
          <p>Germany</p>
          <p>(hereinafter referred to as “Seller”).</p>
          <p>Conflicting customer terms are not accepted.</p>
        </li>
        <li>
          <div class="t1">2. Contract Partner and Conclusion</div>
          <div class="t3">
            <div class="t2">The product presentation does not constitute a legally binding offer but an invitation to order.</div>
            <div class="t2">By clicking the order button, the customer submits a binding offer.</div>
            <div class="t2">The contract is concluded through:</div>
            <ul class="agreementList">
              <li>order confirmation, or </li>
              <li>shipment of goods </li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">3. Contract Language and Storage</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Contract language is German</li>
              <li>Contract text is stored and sent by email</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">4. Prices and Shipping Costs</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Prices include VAT (if applicable) </li>
              <li>Shipping costs are shown separately</li>
            </ul>
          </div>
        </li>
        
        <li>
          <div class="t1">5. Payment Terms</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Payment via available methods (e.g. PayPal, credit card) </li>
              <li>Payment is due immediately</li>
              <li>Seller may exclude certain payment methods</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">6. Third-Country Transfers</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Delivery to the address provided</li>
              <li>Delivery times stated on product pages </li>
              <li>Additional customs duties may apply internationally</li>
            </ul>
            <div class="t2">Transfer of risk:</div>
            <ul class="agreementList">
              <li>Consumers: upon delivery</li>
              <li>Businesses: upon handover to carrier</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">7. Retention of Title</div>
          <div class="t3">
            <p>Goods remain property of the seller until fully paid.</p>
          </div>
        </li>
        <li>
          <div class="t1">8. Right of Withdrawal</div>
          <div class="t3">
            <p>Consumers have a statutory right of withdrawal (see below).</p>
          </div>
        </li>
        <li>
          <div class="t1">9. Warranty</div>
          <div class="t3">
            <div class="t2">Statutory warranty rights apply:</div>
            <ul class="agreementList">
              <li>Consumers: 2 years </li>
              <li>Businesses: 1 year (if legally permitted) </li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">10. Liability</div>
          <div class="t3">
            <div class="t2">Unlimited liability for:</div>
            <ul class="agreementList">
              <li>intent </li>
              <li>gross negligence</li>
              <li>injury to life, body, or health</li>
            </ul>
            <div class="t2">Limited liability for:</div>
            <ul class="agreementList">
              <li>breach of essential obligations</li>
              <li>foreseeable damages only</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">11. Trading Card Disclaimer</div>
          <div class="t3">
            <ul class="agreementList">
              <li>Products are randomized </li>
              <li>No guarantee of specific items</li>
              <li>Opened products are excluded from withdrawal</li>
              <li>Condition grading is subjective</li>
            </ul>
          </div>
        </li>
        <li>
          <div class="t1">12. Youth Protection</div>
          <div class="t3">
            <p>Sales only to persons aged 16+ (or 18 if required).</p>
          </div>
        </li>
        <li>
          <div class="t1">13. Applicable Law</div>
          <div class="t3">
            <p>German law applies (excluding UN sales law).</p>
            <p>Consumer protection laws of the customer’s country remain unaffected.</p>
          </div>
        </li>
        <li>
          <div class="t1">14. Dispute Resolution</div>
          <div class="t3">
            <p>EU Commission platform:</p>
            <p><a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a></p>
            <p>Seller is not willing or obliged to participate.</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about',
  components: {},
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
    }
  },
  mounted() {},
  created() {
    this.closeDialog()
  },
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dislogType.login = false
      this.dislogType.register = false
    },
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/market.css";
@import "../../../static/css/information.css";
.agreementList li{
  list-style: inside;
}
</style>



// WEBPACK FOOTER //
// src/pages/information/useragreement.vue